import { APP_RELEASE_FAMILY, APP_VERSION } from './version';

export const environment = {
  production: true,
  name: 'release',
  APP_VERSION,
  APP_RELEASE_FAMILY,
  AUTH_API_URL: 'https://profinders-microservice-auth-release.up.railway.app',
  COMPANY_API_URL:
    'https://profinders-microservice-company-release.up.railway.app',
  WO_API_URL:
    'https://profinders-microservice-serviceorder-release.up.railway.app',
  NOTIFICATION_API_URL:
    'https://profinders-microservice-notification-release.up.railway.app',
  CEP_API_URL: 'https://viacep.com.br/ws',
  AZURE_URI:
    'https://onsuiteblobstore.blob.core.windows.net/on-suite-teste-filestore',
};
